import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useLayoutEffect } from "react";
import PulseMaterial from "../materials/PulseMaterial";
import { useFrame } from "@react-three/fiber";
import { BackSide, Color } from "three";
const LoadingSphere = (props) => {
    const { radius, ...meshProps } = props;
    useLayoutEffect(() => {
        PulseMaterial.side = BackSide;
    }, []);
    useFrame(({ clock }) => {
        PulseMaterial.uniforms.uTime.value = clock.getElapsedTime() / 1.5;
        PulseMaterial.uniforms.uColor.value = new Color('#f2f2f2');
    });
    return (_jsx("mesh", { ...meshProps, material: PulseMaterial, children: _jsx("sphereGeometry", { args: [radius, 60, 40] }) }));
};
export default memo(LoadingSphere);
